// https://cdn.attn.tv/${attnId}/dtag.js
export type AttnIdToEventAlias = {
	aliasPattern: string;
	attnId: string;
};

export const attnIdToEventAlias: AttnIdToEventAlias[] = [
	{
		aliasPattern: 'strong-new-york',
		attnId: 'strongnewyork',
	},
];

export const GET_ATTN_ID = (pathname: string) =>
	// partial match of the pathname
	// e.g. /strong-new-york-e0y/01-01-2025
	attnIdToEventAlias.find(event => pathname.includes(event.aliasPattern));

export const ENABLE_ATTN = (pathname: string) => !!GET_ATTN_ID(pathname);
